<template>
  <div>
    <h3 class="text-h6 mb-1" style="font-weight:400">
      {{ getTitle }}
    </h3>

    <div v-if="table.data.length === 0" class="elevation-1 white pa-4 text-minimum-gray font-italic">
      {{ $t('paging.noRecords' ) }}
    </div>

    <v-data-table v-else
                  :items="table.data"
                  hide-default-header
                  hide-default-footer
                  class="elevation-1">
      <template slot="header" slot-scope="props">
        <thead>
          <tr>
            <th v-for="header in table.headers"
                :key="header.text"
                :class="header.class">
              {{ header.text }}
            </th>
            <th v-if="table.name === 'docketEntries'" class="text-center">
              <span>{{ $t('caseView.summary.hasDocs') }}</span>
            </th>
          </tr>
          <tr v-if="table.totalItems > getMaxRows">
            <th style="white-space:normal;text-align:left;" :colspan="props.headers.length">
              {{ $t('caseView.summary.rowWarning', {totalRows: table.totalItems, maxRows: getMaxRows}) }}
            </th>
          </tr>
        </thead>
      </template>
      <template slot="item" slot-scope="props">
        <tr>
          <dynamic-value
            v-for="(header, i) in table.headers"
            tag-type="td"
            :data-type="header.dataTypeValue"
            :value="getNestedProperty(props.item, header.modelValue)"
            :key="i"
            :data-label="header.label"/>
          <td v-if="table.name === 'docketEntries'" class="text-center">
            <v-icon v-if="hasAccess($PACONST.COMPONENT_DOCUMENTS_DOCKET_ENTRY, $PACONST.PERMISSION_TYPES.READ)
            && props.item.hasDocuments">
              mdi-checkbox-marked-outline
            </v-icon>
            <v-icon v-else>
              mdi-checkbox-blank-outline
            </v-icon>
          </td>
        </tr>
      </template>
      <template v-if="table.totalItems > 0" slot="footer">
        <div class="text-body-2 pa-4 text-minimum-gray" style="border-top:1px solid #e0e0e0">
          {{ $t('caseView.summary.totalRecords',
                {totalRows: table.totalItems > getMaxRows ? getMaxRows : table.totalItems}) }}
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import PAUTIL from '@/support/utility';
import { mapGetters } from 'vuex';

export default {
  components: { },
  props: {
    table: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('user', ['hasAccess']),
    getTitle () {
      return this.$t('caseView.tab.' + this.table.name);
    },
    getMaxRows () {
      return this.$PACONST.MAX_SUMMARY_RESULTS_LIMIT;
    }
  },
  methods: {
    getNestedProperty (obj, property) {
      let val = PAUTIL.resolvePath(obj, property);
      return val;
    }
  }
};
</script>
